<template>
    <div>

        <div class="container mb-4">

            <h2 class="k-h-secondary">Odpovědi ({{ responsesCount || 0 }})</h2>

            <discussion-response-form
                    ref="commentForm"
                    :url="submitUrl"
                    :method="submitMethod"
                    @responseAdded="getDataAndScroll"
            ></discussion-response-form>

        </div>

        <div class="container mb-3">

            <transition-group name="list-complete" tag="div">
                <template v-for="response in responses">

                    <div :key="response.id" :ref="`response-${response.id}`" class="k-panel k-panel--grid mb-3">
                        <div class="k-panel__body--3-4 k-border-right">
                            <div class="k-panel__body ">
                                {{ response.content }}
                            </div>


                            <div class="k-panel__footer justify-content-between align-items-center">
                                <div class="k-panel__footer-btn">
                                    <a
                                            @click="$refs.commentForm.reactOnResponse(response)"
                                            href="javascript:;"
                                            class="k-action mr-3"
                                    >
                                        <svg class="" role="img" width="12" height="11">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#reply"></use>
                                        </svg>
                                        Reagovat
                                    </a>

                                    <a
                                            @click="likeResponse(response)"
                                            href="javascript:;"
                                            class="k-action"
                                            :class="[{'k-action--disabled': response.like_url === null}]"
                                    >
                                        <svg class="" role="img" width="12" height="11">
                                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#like"></use>
                                        </svg>
                                        Poděkovat autorovi ({{ response.likes_count }})
                                    </a>
                                </div>


                                <a v-if="response.delete_url !== null"
                                   @click="deleteResponse(response)"
                                   href="javascript:;"
                                   class="k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex"
                                >
                                    <svg class="" role="img" width="12" height="11">
                                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use>
                                    </svg>
                                    Odstranit příspěvek
                                </a>
                            </div>
                        </div>

                        <div class="k-panel__body k-panel__body--1-4 border-bottom-0">

                            <div class="k-user-contact">
                                <div class="k-user-contact__image">
                                    <img :src="response.user.prev_url" >
                                </div>

                                <div class="k-user-contact__meta">
                                    <a :title="response.user.name" :href="response.user.detail_url">
                                        <div class="k-user-contact__name">
                                            {{ response.user.name }}
                                        </div>
                                    </a>

                                    <div class="k-user-contact__date">
                                        Vloženo: {{ response.created_at }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div :key="reaction.id" :ref="`response-${reaction.id}`" v-for="reaction in response.reactions" class="k-panel k-panel--grid mb-3 k-panel--loffset-1">
                        <div class="k-panel__body--3-4-fluid k-border-right">
                            <div class="k-panel__body ">
                                {{ reaction.content }}
                            </div>
                            <div class="k-panel__footer justify-content-between align-items-center">
                                <div class="k-panel__footer-btn">
                                    <a @click="$refs.commentForm.reactOnResponse(reaction)" href="javascript:;" class="k-action mr-3"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#reply"></use></svg>
                                        Reagovat
                                    </a>
                                    <a @click="likeResponse(reaction)" href="javascript:;" class="k-action" :class="[{'k-action--disabled': reaction.like_url === null}]"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#like"></use></svg>
                                        Poděkovat autorovi ({{ reaction.likes_count }})
                                    </a>
                                </div>
                                <a v-if="reaction.delete_url !== null" @click="deleteResponse(reaction)" href="javascript:;" class="k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex"><svg role="img" width="12" height="11" class=""><use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use></svg>
                                    Odstranit příspěvek
                                </a>
                            </div>
                        </div>
                        <div class="k-panel__body k-panel__body--1-4-fix border-bottom-0">
                            <div class="k-user-contact">
                                <div class="k-user-contact__image">
                                    <img :src="reaction.user.prev_url" alt="">
                                </div>
                                <div class="k-user-contact__meta">
                                    <a :title="reaction.user.name" :href="reaction.user.detail_url">
                                        <div class="k-user-contact__name">
                                            {{ reaction.user.name }}
                                        </div>
                                    </a>
                                    <div class="k-user-contact__date">
                                        Vloženo: {{ reaction.created_at }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
            </transition-group>


        </div>
    </div>
</template>

<script>
    import DiscussionResponseForm from '../../forms/discussion/DiscussionResponseForm';
    export default {
        components: {
            DiscussionResponseForm
        },

        props: {
            /**
             * Urls
             */
            reactionsUrl: {
                type: String,
                required: true
            },
            submitUrl: {
                type: String,
                required: true
            },
            submitMethod: {
                type: String,
                required: true
            },
            /**
             * Scroll to comment on load
             */
            scrollToId: {
                type: Number,
                default: null
            }
        },

        data: () => ({
            responses: [],
            is_submitted: false
        }),

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function() {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.reactionsUrl,
                        params: {
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.responses = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Like response
             *
             * @param response
             * @returns void
             */
            likeResponse: async function(response) {
                if (response.like_url !== null && this.is_submitted === false) {
                    this.is_submitted = true;
                    try{
                        let result = await axios({
                            method: 'POST',
                            url: response.like_url
                        });
                        if (result.status === 200 && result.data) {
                            if (result.data.success === true) {
                                response.likes_count += 1;
                                response.like_url = null;
                            }
                            if (result.data.message.length) {
                                flash(result.data.message, result.data.success ? 'success' : 'danger');
                            }
                        }
                        else {
                            flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        }
                    }
                    catch (e) {
                        flash('Došlo k chybě při zpracování požadavku.', 'danger');
                        console.log(e.message);
                    }
                    this.is_submitted = false;
                }
            },

            /**
             * Delete response
             *
             * @param response
             * @returns void
             */
            deleteResponse: async function(response) {
                if (response.delete_url !== null && this.is_submitted === false) {
                    let confirm = await this.$swal({
                        title: 'Opravdu chcete odstranit příspěvek?',
                        text: "Příspěvek a všechny reakce budou odstraněny.",
                        type: 'warning',
                        showCancelButton: true
                    });
                    if (confirm.value === true) {
                        this.is_submitted = true;
                        try{
                            let result = await axios({
                                method: 'DELETE',
                                url: response.delete_url
                            });
                            if (result.status === 200 && result.data) {
                                if (result.data.success === true) {
                                    this.getData();
                                }
                                if (result.data.message.length) {
                                    flash(result.data.message, result.data.success ? 'success' : 'danger');
                                }
                            }
                            else {
                                flash('Došlo k chybě při zpracování požadavku.', 'danger');
                            }
                        }
                        catch (e) {
                            flash('Došlo k chybě při zpracování požadavku.', 'danger');
                            console.log(e.message);
                        }
                        this.is_submitted = false;
                    }
                }
            },

            /**
             * Get data and scroll to given response by id
             *
             * @param id
             * @returns void
             */
            getDataAndScroll: async function(id) {
                await this.getData();
                setTimeout(() => {
                    if (this.$refs['response-' + id]) {
                        this.$scrollTo(this.$refs['response-' + id][0], 1000, {offset: -90});
                    }
                }, 100);
            }
        },

        computed: {
            responsesCount: function() {
                let responsesCount = this.responses.reduce((total, response) => {
                    return total + response.reactions.length;
                }, 0);
                return responsesCount + this.responses.length;
            }
        },

        mounted() {
            if (this.scrollToId !== null) {
                this.getDataAndScroll(this.scrollToId);
            }
            else {
                this.getData();
            }
        }
    }
</script>

<style scoped>

    .list-complete-enter-active, .list-complete-leave-active {
        transition: opacity .5s;
    }
    .list-completee-enter, .list-complete-leave-to {
        opacity: 0;
    }
</style>
